import * as THREE from "three";
import FileType from "../../../../../models/enums/file-type.ts";
import PlanOrigin from "../../project-organisation/models/plan-origin.ts";
import KnownScaleContent from "../../project-organisation/models/known-scale-content.ts";
import UserDefinedContent from "../../project-organisation/models/user-defined-content.ts";

class FileRecord {
    fileRevisionId: string;

    fileId: string;

    name: string;

    fileType: FileType;

    relativePath: string;

    origin: PlanOrigin;

    sitePosition: THREE.Vector3 | undefined;

    content: KnownScaleContent | UserDefinedContent | undefined;

    dimensions: { width: number, height: number } | undefined;

    constructor(fileRevisionId: string, fileId: string, name: string, fileType: FileType, filePath: string, origin: PlanOrigin, content: KnownScaleContent | UserDefinedContent, sitePosition: THREE.Vector3 | undefined) {
        this.fileRevisionId = fileRevisionId;
        this.fileId = fileId;
        this.name = name;
        this.fileType = fileType;
        this.relativePath = filePath;
        this.origin = origin;
        this.content = content;
        this.sitePosition = sitePosition;
    }

    setDimensions(width: number, height: number) {
        this.dimensions = { width, height };
    }
}

export default FileRecord;